<template>
  <div id="app-container">
    <div v-if="store.loading" class="status-screen">
      <h1>正在解构色彩维度...</h1>
    </div>
    <div v-else-if="store.error" class="status-screen error-screen">
      <div>
        <h1>[ 数据链接中断 ]</h1>
        <p class="error-message">{{ store.error }}</p>
      </div>
    </div>
    <div v-else class="main-layout">
      <SceneHeader />

      <FilterPanel />
      <ColorScapeScene />
      <HoverInfo />
      <ColorDetailPanel />
      <DebugPanel />
      <ColorTravelMap 
      v-if="store.isTravelMapVisible" 
      :color-data="store.activeTravelMapColor"
      @close="store.hideColorTravelMap()"
    />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useMainStore } from './stores/mainStore.js';
import ColorScapeScene from './components/ColorScapeScene.vue';
import FilterPanel from './components/FilterPanel.vue';
import ColorDetailPanel from './components/ColorDetailPanel.vue';
import HoverInfo from './components/HoverInfo.vue'; // 【新增】导入 HoverInfo 组件
import DebugPanel from './components/DebugPanel.vue';
import ColorTravelMap from './components/ColorTravelMap.vue';

const store = useMainStore();

onMounted(() => {
  store.initDatabase();
});
</script>

<style scoped>
/* Styles remain the same */
.main-layout {
  width: 100vw;
  height: 100vh;
  position: relative;
}

#app-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #fff;
  color: #000;
}

.status-screen {
  color: #000;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.status-screen h1 {
  font-weight: 500;
  font-size: 1.5rem;
  letter-spacing: 2px;
}

.error-screen .error-message {
  color: #d90000;
  font-weight: 400;
  background: #ffe5e5;
  padding: 1rem;
  margin-top: 1rem;
  border: 1px solid #ffc1c1;
  max-width: 800px;
}
</style>